import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import filterMiddleware from "./components/Whiteboard/filterMiddleware";

import rootReducer from "reducers/rootReducer.js";

import rootSaga from "sagas/rootSaga";

const sagaMiddleware = createSagaMiddleware();
const storeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  rootReducer,
  storeEnhancer(applyMiddleware(sagaMiddleware, filterMiddleware))
);

sagaMiddleware.run(rootSaga);
